/** مواقع تعريفية — صور من aait.sa (مرتبطة بمحتوى الصورة وليس تسمية الملف في ووردبريس) */

const AAIT_SITES = '/images/portfolio';
const v = '?v=3';

export const portfolioData = [
  {
    title: 'منصة إقرار',
    category: 'منصة خدمات',
    description:
      'منصة إقرار للخدمات المحاسبية والاستشارية — محاسبة، زكاة، وضريبة القيمة المضافة.',
    image: `${AAIT_SITES}/iqrar.png${v}`,
    imageBg: 'from-teal-600/25 via-teal-950/40 to-slate-900',
  },
  {
    title: 'موقع شاهقة',
    category: 'موقع عقاري',
    description:
      'موقع شاهقة للعقارات — واجهة تعرض المشاريع والهوية مع تجربة حجز وتواصل سلسة.',
    image: `${AAIT_SITES}/shahiqa.png${v}`,
    imageBg: 'from-slate-500/20 via-slate-900 to-slate-950',
  },
  {
    title: 'موقع العايد',
    category: 'موقع شركة',
    description:
      'موقع مجموعة العايد الصناعية — عرض خطوط الإنتاج مثل المنازل والحدائق والمنتجات الصناعية.',
    image: `${AAIT_SITES}/alayed.png${v}`,
    imageBg: 'from-blue-500/25 via-blue-950/35 to-slate-900',
  },
  {
    title: 'موقع ناثان',
    category: 'تأجير سيارات',
    description:
      'موقع ناثان لتأجير السيارات — عرض الأسطول والفروع في جدة ودبي مع حجز إلكتروني.',
    image: `${AAIT_SITES}/nathan.png${v}`,
    imageBg: 'from-red-500/20 via-red-950/40 to-slate-900',
  },
  {
    title: 'الاتحاد السعودي للكاراتيه',
    category: 'موقع مؤسسي',
    description:
      'بوابة الاتحاد السعودي للكاراتيه — تسجيل الأعضاء، الأخبار، والبرامج الرياضية.',
    image: `${AAIT_SITES}/karate.png${v}`,
    imageBg: 'from-emerald-500/25 via-emerald-950/30 to-slate-900',
  },
  {
    title: 'منصة بدل',
    category: 'منصة إعلانات',
    description:
      'منصة بدل للإعلانات المبوبة — أقسام السيارات والعقارات والمطاعم مع إضافة إعلانات.',
    image: `${AAIT_SITES}/badel.png${v}`,
    imageBg: 'from-amber-500/20 via-amber-950/30 to-slate-900',
  },
];
